import { useState } from 'react';
import { faqs } from '@/mocks/comicData';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-4 lg:flex-row lg:gap-10">
          <div className="w-full lg:w-2/5">
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
              <i className="ri-question-line"></i>常见问题
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              找书小贴士
            </h2>
            <p className="mt-3 text-sm leading-6 text-foreground-600 md:text-base">
              关于虫虫漫画分类大全的使用方法，最常见的问题都整理在这里。
              如果还有疑问，欢迎通过页脚的联系表单告诉我们。
            </p>
            <div className="mt-6 hidden gap-3 lg:flex">
              <span className="flex items-center gap-2 rounded-lg bg-accent-100 px-4 py-3 text-sm font-semibold text-accent-800">
                <i className="ri-tools-line"></i>持续收录更新
              </span>
              <span className="flex items-center gap-2 rounded-lg bg-secondary-100 px-4 py-3 text-sm font-semibold text-secondary-800">
                <i className="ri-chat-smile-line"></i>帮你找书
              </span>
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <div className="flex flex-col gap-3">
              {faqs.map((f, idx) => {
                const active = openIndex === idx;
                return (
                  <div
                    key={f.q}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(active ? null : idx)}
                      aria-expanded={active}
                      className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                    >
                      <h3 className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</h3>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          active ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                        }`}
                      >
                        <i className={`ri-add-line transition-transform ${active ? 'rotate-45' : ''}`}></i>
                      </span>
                    </button>
                    {active && (
                      <div className="border-t border-background-200 px-4 pb-4 pt-3 md:px-5">
                        <p className="text-sm leading-6 text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}